import { Unit, Module } from "@apis/index";
import AccessDenied from "@components/access-denied";
import { deletesvg, edit } from "@assets/icons";
import Header from "@commons/header";
import Column from "@components/column";
import Table from "@components/table";
import { useModal } from "@context/ModalContext";
import { Actions, RootState } from "@store/index";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQueryState } from "@hooks/useQueryState";

const UnitTable = ({ moduleId }) => {
  const {
    data: units,
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.units);

  const [page, setPage] = useQueryState<number>("page", 1);
  const [search, setSearch] = useState("");

  const [error, setError] = useState<string | null>(null);

  const fetchUnits = async () => {
    setError(null);
    try {
      await Unit.list({
        state: "units",
        params: { page, moduleId, limit: 30, search },
      });
    } catch (err: any) {
      console.error("Failed to fetch units:", err);
      setError(err.message || "Failed to load units");
    }
  };

  useEffect(() => {
    if (moduleId) fetchUnits();
  }, [page, moduleId, search]);

  useEffect(() => {
    setPage(1);
  }, [search]);

  const columns = [
    {
      title: "SN",
      key: "sn",
      render: (_item: any, index: number) => index,
    },
    {
      title: "Module",
      key: "module",
      render: (item: any) => item.module?.name || "-",
    },
    {
      title: "Unit Name",
      key: "name",
      render: (item: any) => item.name.toUpperCase(),
    },
  ];
  const navigate = useNavigate();

  if (error) {
    return (
      <Column>
        <AccessDenied
          message={error}
          onRetry={fetchUnits}
        />
      </Column>
    );
  }

  return (
    <Column>
      <Table
        columns={columns}
        data={units}
        totalItems={totalItems}
        totalPages={totalPages}
        pageControlled={page}
        onPageChange={setPage}
        itemsPerPage={30}
        hasSearchbar={true}
        onSearchChange={setSearch}
        text="Units List"
        actions={[
          {
            key: "edit",
            icon: edit,
            onClick: (item) => {
              navigate(`/admin/product-management/units/${item.id}`, {
                state: item,
              });
            },
          },
        ]}
      />
    </Column>
  );
};

export default UnitTable;
